const icon = require('vue-svgicon');
icon.register({
    'telegram': {
        width: 18,
        height: 18,
        viewBox: '0 0 18 18',
        data: `<path pid="0" d="M15.92 3.085L1.747 8.38c-.967.377-.962.9-.177 1.133l3.638 1.1 8.42-5.147c.397-.235.761-.108.462.149l-6.82 5.964h-.002.001l-.25 3.634c.367 0 .53-.163.735-.356l1.768-1.665 3.676 2.63c.678.362 1.165.176 1.333-.607l2.414-11.019c.247-.96-.378-1.394-1.025-1.11z" _fill="#F9F9FC"/>`,
    },
});
